export default __webpack_public_path__ + "static/media/portadaGs360Home.743b9ce9.png";